<template>
  <div class="d-flex justify-content-center align-items-center full-height">
    <div class="p-4 rounded shadow-lg">
      <img src="@assets/images/logo-processus-c.svg" class="mb-3" />
      <h4 class="mb-5 text-white">Bienvenido al portal<br />Backoffice de Processus</h4>
      <DxButton @click="doEnter" type="success" class="d-flex">{{ $t("shared.ui.buttons.access") }}</DxButton>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useRouter } from "@/.shared/services/routing-services";
import { useAuthentication } from "@services/auth/authentication";
import DxButton from "devextreme-vue/button";

const props = defineProps<{ redirectTo?: string }>();
const router = useRouter();
const auth = useAuthentication();

function doEnter() {
  if (auth.isLoggedIn()) {
    if (props.redirectTo) router.replace(props.redirectTo);
    else router.replace({ name: "private-home" });
  } else {
    auth.login(`${import.meta.env.BASE_URL}${props.redirectTo ?? ""}`);
  }
}
</script>
<style scoped lang="scss">
.full-height {
  background-size: cover;
  background:
    radial-gradient(ellipse at 30% 15%, rgba(26, 130, 110, 0.9) 0%, transparent 48%),
    radial-gradient(ellipse at 85% 85%, rgba(14, 107, 140, 0.8) 0%, transparent 45%), var(--background-primary-default);
  height: 100%;
}
.full-height > div {
  background-color: rgba(255, 255, 255, 0.2);
}
</style>
